export type PreviewPage = {
  image: string
  tag: string
  title: string
  text: string
}

export const previewPages: PreviewPage[] = [
  {
    image:
      'https://cdn.magicpatterns.com/uploads/6Jso72FxJwSByTA2LeFVLj/Captura_de_pantalla_2026-09-19_a_las_6.36.22_p.webp',
    tag: 'Laboratorio pratico',
    title: 'Arte dal Riciclo — Il Robot del Futuro',
    text: 'Ogni lezione arriva con materiali, consegna e risultato finale già illustrati.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/k1sQxgnJGJ35H5MMPx2aKJ/Captura_de_pantalla_2026-09-19_a_las_6.38.15_p.webp',
    tag: 'Passo dopo passo',
    title: 'Texture in 3D: Il Rilievo',
    text: 'Cinque passaggi fotografati e temporizzati: 60 minuti di lezione già pronti.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/pDj6repqLcAwcDUuCiFTAK/Captura_de_pantalla_2026-09-19_a_las_6.42.57_p.webp',
    tag: 'Storia dell’arte in pratica',
    title: 'Dipingere su Papiro',
    text: 'Il mondo antico diventa un laboratorio con materiali che hai già in aula.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/eEGuZcCQDoJ1xM7XrRxmUT/Captura_de_pantalla_2026-09-19_a_las_6.43.48_p.webp',
    tag: 'Lettura dell’opera',
    title: 'Analisi — Kandinsky, Composizione VIII',
    text: 'Schede di analisi annotate per guidare la classe senza preparare nulla.',
  },
  {
    image:
      'https://cdn.magicpatterns.com/uploads/fdoXPimS1WKEZXzFYpYPhy/Captura_de_pantalla_2026-09-19_a_las_6.44.31_p.webp',
    tag: 'Scheda stampabile',
    title: 'Unità 2 — Attività Pratiche',
    text: 'Esercizi graduati con spazio per disegnare: stampa e distribuisci.',
  },
]
